import { createFileRoute } from "@tanstack/react-router";
import { MaskRedirect } from "@/features/shared/route-masking";

export const Route = createFileRoute("/admin/campaigns/create")({
  component: () => (
    <MaskRedirect
      to="/admin/campaigns"
      action="create"
      mask="/admin/campaigns/create"
    />
  ),
});
